import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.AUTH}/v3/notifications`;

async function fetchNotifications() {
  try {
    const response = await api.get(basePath);

    const treated = errorHandling.handleResponse(
      response,
      "notificationsService.fetchNotifications"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "notificationsService.fetchNotifications");
    return null;
  }
}

async function updateNotification(eventId, isActive) {
  try {
    const payload = { EventId: eventId, Active: isActive ? "S" : "N" };
    const response = await api.put(basePath, JSON.stringify(payload));

    if (response.status === 204) {
      return { success: true };
    }

    const treated = errorHandling.handleResponse(
      response,
      "notificationsService.updateNotification"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "notificationsService.updateNotification");
    return {
      error: true,
      status: error?.response?.status,
      message: error?.response?.data?.message,
      validations: error?.response?.data?.validations,
    };
  }
}

export const notificationsService = {
  fetchNotifications,
  updateNotification,
};
